// extracted by mini-css-extract-plugin
module.exports = {"container":"Splash_container__zxZF5","title":"Splash_title__0VNIt","list":"Splash_list__VZIMn"};